interface Period {
  title: string;
  externalId: string;
  customerId: string;
  path: string;
  createdAt: string;
  startDate: string;
  endDate: string;
  viewed: boolean;
}

export const getExistStatementsYears = (data: any) => {
  if (!data) return [];
  const { buckets, mainAccount } = data;
  const statementsArray = mainAccount;
  if (!statementsArray && !buckets) return [];
  if (!statementsArray.length && !buckets.length) return [];
  const yearsArr: number[] = [];
  if (statementsArray.length) {
    statementsArray.forEach((bucket: any) => {
      yearsArr.push(bucket.year);
    });
  } else if (buckets.length) {
    buckets.forEach((bucket: any) => {
      yearsArr.push(bucket.year);
    });
  }
  return yearsArr;
};

export const getExistExpensesYears = (taxStatement: Period[]): number[] => {
  const yearsArr: number[] = [];
  taxStatement.forEach((p: Period) => {
    const year = Number(p.endDate.substring(0, 4));
    yearsArr.push(year);
  });
  // @ts-ignore
  return [...new Set(yearsArr)];
};
